import { observer } from 'mobx-react-lite'
import { useChatbotContext } from 'pages/chatbot/context'
import { ChatbotCollapse } from 'pages/chatbot/ui/ChatbotCollapse'
import { AgentKnowledgeBase } from 'pages/chatbot/ui/AgentKnowledgeBase/AgentKnowledgeBase'
import { PointMaxAttempts } from './PointMaxAttempts'
import { PointInstructions } from './PointInstructions'
import styles from './styles.module.scss'

export const StepConfigure = observer(() => {
  const {
    errors,
    agentKnowledgeBaseStore,
    model: { settings, setKnowledgeBaseDocuments, knowledgeBaseDocuments },
  } = useChatbotContext()

  const isNestedError =
    errors.hasError('settings.max_attempts.value') ||
    errors.hasError('settings.use_knowledge_base') ||
    errors.hasError('settings.instructions') ||
    errors.hasError('knowledge_base_documents') ||
    !!agentKnowledgeBaseStore.agentDocumentsStore.documentsError

  const configureError = isNestedError ? 'Please complete all the fields' : null

  return (
    <ChatbotCollapse
      icon='settings'
      title='Set your conversation style'
      tooltipProps={{
        label: 'Configure the length, tone, and topic of your AI Agent’s conversation',
        placement: 'top',
        breakWord: true,
        maxWidth: 360,
      }}
      error={configureError}
    >
      <div className={styles.container}>
        <AgentKnowledgeBase
          agentKnowledgeBaseStore={agentKnowledgeBaseStore}
          knowledgeBaseUsageError={{
            message: errors.getError('settings.use_knowledge_base.value') ?? '',
            resetError: () => errors.removeError('settings.use_knowledge_base'),
          }}
          knowledgeBaseDocumentsError={{
            message: errors.getError('knowledge_base_documents') ?? '',
            resetError: () => errors.removeError('knowledge_base_documents'),
          }}
          setKnowledgeBaseUsage={settings.setKnowledgeBaseUsage}
          knowledgeBaseUsage={settings.knowledgeBaseUsage}
          setKnowledgeBaseDocuments={setKnowledgeBaseDocuments}
          knowledgeBaseDocuments={knowledgeBaseDocuments}
          title={'Use knowledge base?'}
          isOnlyButton
        />
        <PointMaxAttempts />
        <PointInstructions />
      </div>
    </ChatbotCollapse>
  )
})
